// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card {
    border-radius: 20px;
    padding: 20px;
    background-color: #fff;
    box-shadow: 1px 4px 8px 3px rgba(0, 0, 0, 0.1);
}
.title {
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 20px;
}
hr {
    margin-top: 1rem;
    margin-bottom: 1rem;
    border: 0;
    border-top: 1px solid rgba(0, 0, 0, .1);
}
h2 {
    margin-bottom: 5px;
}
h4 {
    margin-bottom: 3px;
}
p {
    margin-bottom: 15px;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 1.1rem;
    font-weight: 500;
}
ul {
    font-size: 15px;
}`, "",{"version":3,"sources":["webpack://./assets/css/conditionsfontstyles.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,8CAA8C;AAClD;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,SAAS;IACT,uCAAuC;AAC3C;AACA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,mBAAmB;IACnB,yCAAyC;IACzC,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,eAAe;AACnB","sourcesContent":[".card {\n    border-radius: 20px;\n    padding: 20px;\n    background-color: #fff;\n    box-shadow: 1px 4px 8px 3px rgba(0, 0, 0, 0.1);\n}\n.title {\n    font-size: 24px;\n    font-weight: bold;\n    margin-bottom: 20px;\n}\nhr {\n    margin-top: 1rem;\n    margin-bottom: 1rem;\n    border: 0;\n    border-top: 1px solid rgba(0, 0, 0, .1);\n}\nh2 {\n    margin-bottom: 5px;\n}\nh4 {\n    margin-bottom: 3px;\n}\np {\n    margin-bottom: 15px;\n    font-family: Arial, Helvetica, sans-serif;\n    font-size: 1.1rem;\n    font-weight: 500;\n}\nul {\n    font-size: 15px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
